import LocationInventoryComponent from "../components/location-inventory.component";

export default function LocationInventoryPage() {
  return (
    <div>
      <LocationInventoryComponent />
    </div>
  );
}
